import PositionableCrudRepository from '@/repositories/PositionableCrudRepository';
import RowPage from '@/repositories/data/content/row/RowPage';
import HttpClient from '@/util/http/HttpClient';

export default class RowPageRepository extends PositionableCrudRepository<number, RowPage, RowPage> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/row-page/');
    }
}
